import { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

const SET_USER_CONNECTION_STATUS = 'SET_USER_CONNECTION_STATUS'
const SET_SOCKET_STATUS = 'SET_SOCKET_STATUS'
const SET_EMQX_STATUS = 'SET_EMQX_STATUS'
const SET_GENERAL_API_STATUS = 'SET_GENERAL_API_STATUS'
const SET_LIVE_API_STATUS = 'SET_LIVE_API_STATUS'
const SET_SHOW_CONNECTION_INFORM = 'SET_SHOW_CONNECTION_INFORM'
const SET_REVIEW_CONNECTION_OVERRIDE = 'SET_REVIEW_CONNECTION_OVERRIDE'

const REVIEW_OVERRIDE_VALUES = [
  CONNECTION_STATUS.GOOD,
  CONNECTION_STATUS.UNSTABLE,
  CONNECTION_STATUS.RECONNECTING,
]

const _state = {
  userConnectionStatus: CONNECTION_STATUS.ERROR,
  generalApiStatus: CONNECTION_STATUS.GOOD,
  liveApiStatus: CONNECTION_STATUS.GOOD,
  socketStatus: CONNECTION_STATUS.ERROR,
  emqxStatus: CONNECTION_STATUS.ERROR,
  isReconnecting: false,
  showConnectionInform: false,
  reviewConnectionOverride: null,
}

const getters = {
  userConnectionStatus: (state) => state.userConnectionStatus,
  generalApiStatus: (state) => state.generalApiStatus,
  liveApiStatus: (state) => state.liveApiStatus,
  socketStatus: (state) => state.socketStatus,
  emqxStatus: (state) => state.emqxStatus,
  showConnectionInform: (state) => state.showConnectionInform,
  connectionStatus: (state, _, __, rootGetters) => {
    if (state.reviewConnectionOverride && rootGetters['featureToggles/canUseHamburgerMenu']) {
      return state.reviewConnectionOverride
    }
    if (state.isReconnecting) {
      return CONNECTION_STATUS.RECONNECTING
    }
    if (state.userConnectionStatus === CONNECTION_STATUS.ERROR) {
      return CONNECTION_STATUS.RECONNECTING
    }
    if (rootGetters['featureToggles/canUseNewChangeSlideMechanism']) {
      // when the flag is on, rely on the emqx connection for
      // network status, because it's the most important indicator of network health
      if (state.emqxStatus === CONNECTION_STATUS.ERROR) {
        // when mqtt is disconnected, it will reconnect by default
        // so we show the status as reconnecting
        return CONNECTION_STATUS.RECONNECTING
      }
    }
    if (state.generalApiStatus === CONNECTION_STATUS.UNSTABLE) {
      return CONNECTION_STATUS.UNSTABLE
    }
    return CONNECTION_STATUS.GOOD
  },
}

const actions = {
  setUserConnection({ commit }, payload) {
    commit(SET_USER_CONNECTION_STATUS, payload)
    if (payload === CONNECTION_STATUS.ERROR) {
      commit(SET_SHOW_CONNECTION_INFORM, true)
    }
  },
  setSocketConnection({ commit }, payload) {
    commit(SET_SOCKET_STATUS, payload)
  },
  setEmqxConnection({ commit, rootGetters }, payload) {
    commit(SET_EMQX_STATUS, payload)
    if (rootGetters['featureToggles/canUseNewChangeSlideMechanism']) {
      if (payload === CONNECTION_STATUS.ERROR) {
        commit(SET_SHOW_CONNECTION_INFORM, true)
      } else {
        commit(SET_SHOW_CONNECTION_INFORM, false)
      }
    }
  },
  setGeneralApiConnection({ commit }, payload) {
    commit(SET_GENERAL_API_STATUS, payload)
  },
  setLiveApiConnection({ commit }, payload) {
    commit(SET_LIVE_API_STATUS, payload)
  },
  setShowConnectionInform({ commit }, payload) {
    commit(SET_SHOW_CONNECTION_INFORM, payload)
  },
  setReviewConnectionOverride({ commit }, payload) {
    commit(SET_REVIEW_CONNECTION_OVERRIDE, REVIEW_OVERRIDE_VALUES.includes(payload) ? payload : null)
  },
}

const mutations = {
  [SET_USER_CONNECTION_STATUS](state, payload) {
    state.userConnectionStatus = payload
  },
  [SET_SOCKET_STATUS](state, payload) {
    state.socketStatus = payload
  },
  [SET_EMQX_STATUS](state, payload) {
    state.emqxStatus = payload
  },
  [SET_GENERAL_API_STATUS](state, payload) {
    state.generalApiStatus = payload
  },
  [SET_LIVE_API_STATUS](state, payload) {
    state.liveApiStatus = payload
  },
  [SET_SHOW_CONNECTION_INFORM](state, payload) {
    state.showConnectionInform = payload
  },
  [SET_REVIEW_CONNECTION_OVERRIDE](state, payload) {
    state.reviewConnectionOverride = payload
  },
}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
